export default [
  {
    id: 'seriesTypeId',
    type: 'SeriesType',
    label: 'Series Type Id'
  },
  {
    id: 'seriesTypeDetailId',
    type: 'SeriesTypeDetail',
    label: 'Series Type Detail Id'
  },
  {
    id: 'periodicityId',
    type: 'Periodicity',
    label: 'Periodicity Id'
  },
  {
    id: 'parentObjectTypeId',
    type: 'ParentObjectType',
    label: 'Parent Object Type Id'
  }
];
